import { Component, OnInit, ViewChild } from '@angular/core';
import { Client, Stylist } from '../models';
import { ClientService, UserService, SalonService } from '../services';
import { List } from 'immutable';
import { StylistPickerComponent } from '../components/stylist-picker/stylist-picker.component';
import { ClientPickerComponent } from '../components/smr-client-picker/smr-client-picker.component';
import {
  ActionSheetController,
  AlertController,
  ModalController,
  LoadingController,
  Platform,
} from '@ionic/angular';
import { Utilities } from '../utilities/utilities';
import { Observable } from 'rxjs';
import { ClientFormPageComponent } from '../components/client-form-page/client-form-page.component';
import { Router, ActivatedRoute } from '@angular/router';
import { NavigationStateService } from '../services/navigation-state.service';

export interface IClientFormCallBackData {
  client: Client;
  action: string;
}
@Component({
  selector: 'smr-clients',
  templateUrl: './clients.page.html',
  styleUrls: ['./clients.page.scss'],
})
export class ClientsPage implements OnInit {
  @ViewChild(StylistPickerComponent)
  stylistPickerComponent: StylistPickerComponent;
  @ViewChild(ClientPickerComponent)
  clientPickerComponent: ClientPickerComponent;

  public clientInfo;

  public stylist: Stylist;

  public stylistID: number;

  public client: Client;

  public clients: List<Client>;

  public segmentModel: string;

  public isLoading: boolean;

  public errorOccurredWhileLoadingStylistPicker: boolean;

  public readOnlyStylistPicker: boolean;

  public isReadOnly: boolean = false;

  constructor(
    private modalCtrl: ModalController,
    private clientService: ClientService,
    private userService: UserService,
    private loadingCtrl: LoadingController,
    private alertController: AlertController,
    private actionSheetController: ActionSheetController,
    private platform: Platform,
    private router: Router,
    private activateRoute: ActivatedRoute,
    private navigationStateService: NavigationStateService,
    private salonService: SalonService
  ) //private file: File,
  // private fileOpener: typeof FileOpener
  {
    this.readOnlyStylistPicker = true;
    if (this.userService.isLoggedIn()) {
      const user = this.userService.getUser();
      this.stylistID = user.getID();
      if (user.isAdministrator() || user.getViewAllClients()) {
        this.readOnlyStylistPicker = false;
      }
    }
  }

  ngOnInit() { 
    this.isReadOnly = this.salonService.getIsReadOnly();
  }

  ionViewWillEnter() {
    this.activateRoute.params.subscribe((param) => {
        if(param.id) {
           this.onClientDelete(param.id)
        }
    });
  }


  public onClientSelect(client: Client) {
    this.client = client;

    if (!this.showClientDetailsOnTheRightSide()) {
      this.navigationStateService.setState({
        clientID: this.client.id,
      });
      this.router.navigate(['/clients/' + this.client.id])
    }
  }

  public async onClientAdd() {
    if (this.isReadOnly) {
      console.log('isReadOnly', this.isReadOnly);
      return;
    }
    let client: Client = new Client();
    client = client.setStylistID(this.userService.getUser().getID());
    console.log('client', client);
    const clientFormModal = await this.modalCtrl.create({
      component: ClientFormPageComponent,
      componentProps: {
        client: client,
        stylist: this.stylist,
      },
    });
    console.log('clientFormModal', clientFormModal);
    clientFormModal.onDidDismiss().then((data: any) => {
      if (data.data) {
        this.clientPickerComponent.addClient(data.data.client);
        this.onClientSelect(data.data.client);
      }
    });

    clientFormModal.present();
  }

  public onTapToReload() {
    this.isLoading = true;
    this.errorOccurredWhileLoadingStylistPicker = false;
    this.stylistPickerComponent.ngOnInit();
  }

  public onStylistPickerInit(initResponse: {
    success: boolean;
    stylist: Stylist;
  }) {
    if (initResponse.success) {
      this.onStylistSelect(initResponse.stylist);
    } else {
      this.isLoading = false;
      this.errorOccurredWhileLoadingStylistPicker = true;
      // this.content.resize();
    }
  }

  public onStylistSelect(stylist: Stylist) {
    this.isLoading = true;
    if (stylist) {
      this.stylist = stylist;
      this.stylistID = this.stylist.getID();
    }
    this.isLoading = false;
  }

  // selectClient(id) {
  //   this.clientService.loadClientInfo(id).subscribe(res => {this.clientInfo = res; this.segmentModel = "details"})
  // }

  // segmentChanged() {
  // }
  public async showClientExportOptions() {
    const actionSheet = await this.actionSheetController.create({
      buttons: [
        {
          text: 'Export emails to CSV',
          handler: () => {
            this.onClientExport(['email']);
          },
        },
        {
          text: 'Export Mailchimp list',
          handler: () => {
            this.onClientExport(['firstName', 'lastName', 'email']);
          },
        },
        {
          text: 'Export client list',
          handler: () => {
            this.onClientExport();
          },
        },
      ],
    });

    actionSheet.present();
  }

  public async onClientExport(fields?: Array<string>) {
    const loader = await this.loadingCtrl.create({ spinner: 'crescent' });
    loader.present();

    this.clientService.exportToCSV(this.stylistID, fields).subscribe({
      next: (blob: Blob) => {
        if (this.platform.is('capacitor')) {
          this.nativeCSVViewer(blob).subscribe({
            next: (success: boolean) => {
              loader.dismiss(() => { });
            },
            error: (err) => {
              loader.dismiss(async () => {
                const alert = await this.alertController.create(
                  Utilities.getDefaultErrorMessageConfig()
                );
                alert.present();
              });
            },
          });
        } else {
          loader.dismiss();

          // download fiel on the browser
          const url = window.URL.createObjectURL(blob);
          window.open(url);
        }
      },
      error: (err) => {
        loader.dismiss(async () => {
          const alert = await this.alertController.create(
            Utilities.getDefaultErrorMessageConfig()
          );
          alert.present();
        });
      },
    });
  }

  public nativeCSVViewer(blob: Blob): Observable<boolean> {
    return new Observable((observer) => {
      //   const csvFileName: string = 'smr-clients.csv';
      //   const dir: string = this.file.documentsDirectory;
      //   const options: IWriteOptions = {
      //     replace: true,
      //   };
      //   this.file
      //     .writeFile(dir, csvFileName, blob, options)
      //     .then((result) => {
      //       this.fileOpener
      //         .open(dir + csvFileName, 'text/csv')
      //         .then((result) => {
      //           observer.next(true);
      //           observer.complete();
      //         })
      //         .catch((err) => {
      //           observer.error(err);
      //           observer.complete();
      //         });
      //     })
      //     .catch((err) => {
      //       observer.error(err);
      //       observer.complete();
      //     });
    });
  }

  public showClientDetailsOnTheRightSide(): boolean {
    return this.platform.is('desktop') || this.platform.is('tablet');
  }

  // public async onClientEdit() {
  //   const clientFormModal = await this.modalCtrl.create({
  //     component: ClientFormPageComponent,
  //     componentProps: {
  //     client: this.client,
  //     modal: true,
  //     }
  //   });
  //   clientFormModal.onDidDismiss().then((callBackData: any) => {
  //     if (callBackData) {
  //       this.client = callBackData.client;
  //       if (callBackData.action === 'save') {
  //         const data = {
  //           client: this.client,
  //           action: 'save',
  //         };
  //         this.clientPickerComponent.refreshSelectedClient.next(this.client);
  //       } else {
  //         const data = {
  //           client: this.client,
  //           action: 'delete',
  //         };
  //         this.clientPickerComponent.refreshSelectedClient.next(undefined);
  //       }
  //     }
  //   });
  //   clientFormModal.present();
  // }

  public clientMerged(client: Client) {
    this.client = client;
    this.clientPickerComponent.refreshSelectedClient.next(undefined);
  }

  // public onInfiniteScroll ($event: InfiniteScroll) {
  //   this.infiniteScrollMonitor.next($event);
  // }
  public clientEdited(client: Client) 
  {
    this.client = client;
    this.clientPickerComponent.editClient(client);
  }
  public clientUpdate(event) {
    if(event.action === 'delete'){
      this.clientPickerComponent.deleteClient(event.client);

      this.client = undefined;
    } else {
      this.client = event.client;
      this.clientPickerComponent.refreshSelectedClient.next(this.client);
    }
  }
  public onClientDelete(clientId: number): void {
    var clientIndex: number = this.clientPickerComponent.clientList.findIndex(x => x.id === clientId);
    if (clientIndex !== -1) {
      this.clientPickerComponent.clientList.remove(clientIndex);
      this.clientPickerComponent.refreshSelectedClient.next(undefined);
    }
    else {
      this.clientPickerComponent.loadClients();
    }
  }

  public setProfilePhoto(data){
    var clientIndex: number = this.clientPickerComponent.clientList.findIndex(x => x.id === data.id);
    if (clientIndex !== -1) {
      this.clientPickerComponent.clientList = this.clientPickerComponent.clientList.update(clientIndex, client => client.setProfilePhoto(data.profilePhoto))
    }
    else {
      this.clientPickerComponent.loadClients();
    }
  }
}
